import { arrayOf, number, shape, string } from 'prop-types';

const QuantityUnitType = shape({
  q: arrayOf(number),
  u: string,
});

export default QuantityUnitType;
